import React from "react";
import classes from "./ReviewCard.module.scss";
import fullStar from "../../../assets/imgs/reviews/fullStar.svg";
import { Link } from "react-router-dom";
import { ArrowRightAlt } from "@mui/icons-material";
import logo from "../../../assets/imgs/avatar2.png";
const ReviewCard = (props) => {
  const { review } = props;
  function parseDate(date) {
    return new Date(date).toLocaleString().split(",")[0].replaceAll("/", "-");
  }

  return (
    review && (
      <div key={review._id} className={classes.container}>
        <div className={classes.program}>
          <img
            className={classes.program__img}
            src={review?.program?.image}
            alt="program"
          />
        </div>
        <div className={classes.profile}>
          <div className={classes.profile__info}>
            <img
              className={classes.profile__pic}
              src={review?.user?.image ? review?.user?.image : logo}
              alt="profilePic"
            />
            <div>
              <h2>{review?.user?.fullName}</h2>
              {review?.user?.nationality && (
                <p className={classes.profile__nationality}>
                  <small>Nationality:</small> {review?.user?.nationality}
                </p>
              )}
            </div>
          </div>

          <h2 className={classes.program_name}>{review?.program?.name}</h2>
          <p className={classes.program_location}>
            <small>Location: </small>
            {review?.program?.location}
          </p>

          <p className={classes.profile__date}>
            {parseDate(review?.updatedAt)}
          </p>
          <div className={classes.review}>
            <p className={classes.review__text}>
              <small>Review:</small>
              {review?.text}
            </p>
          </div>
          <Link
            to={`/programs/${review?.program?._id}`}
            className={classes.view_program}
            scroll="yes"
          >
            View Program <ArrowRightAlt />
          </Link>
        </div>
      </div>
    )
  );
};

export default ReviewCard;
